
import Vue from 'vue'

import SidebarCategory from '@/pages/top/components/SidebarCategory.vue'
// import SidebarBrands from '@/pages/top/components/SidebarBrands.vue'
// import SidebarPayment from '@/pages/top/components/SidebarPayment.vue'
// import SidebarContact from '@/components/sidebar/SidebarContact.vue'
// import { Carousel } from '@/pages/top/types'

export default Vue.extend({
  name: 'TopPageSidebar',
  components: {
    SidebarCategory
    // SidebarBrands,
    // SidebarPayment,
    // SidebarContact
  },
  props: {
    productCategories: {
      type: Array,
      required: true
    }
    // brandItems: {
    //   type: Array as () => Carousel[],
    //   required: true
    // },
    // showPhoneContact: {
    //   type: Boolean,
    //   required: true
    // },
    // showMailContact: {
    //   type: Boolean,
    //   required: true
    // }
  }
})
